export default "__VITE_ASSET__9e3b624d__"